import { Component, Input, OnInit } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';

@Component({
  selector: 'app-valore-punti-redenti-indicator',
  templateUrl: './valore-punti-redenti-indicator.component.html',
  styleUrls: ['./valore-punti-redenti-indicator.component.css']
})
export class ValorePuntiRedentiIndicatorComponent implements OnInit {

  @Input() data: any;

  constructor(
    private indicatorService: IndicatorsService
  ) { }

  ngOnInit() {
    if (!isUndefined(this.data)) {
      this.indicatorService.indicatorCalculation('ValorePuntiRedenti', this.data).subscribe((res) => {
        console.log('ValorePuntiRedenti', res);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/points/valore-punti-redenti-indicator/valore-punti-redenti-indicator.component.ts